import styled from 'styled-components'
import { device, fonts } from '../../styles/GlobalVariables'

/**
 * RESH13-1138 - closed state of a vertical video inside an article.
 * Figma: mobile 335x595.27 (node 22896:227219), desktop 500x888.46
 * (node 22896:226768). Both are the same component scaled, so every value
 * below is the designed one at that width.
 */
export const Container = styled.div`
  position: relative;
  max-width: 400px;
  /* the design leaves 20px under the block on mobile and 40px on desktop */
  margin: 0 auto 20px;
  /**
   * Article's Content sets the side margins of its children itself - 20px below
   * medium and 0 above it - and that rule outweighs the auto margins above.
   * Under medium the width is therefore left auto, so the block fills what is
   * left of the column and those 20px stay visible, exactly the gutters the
   * design draws (335 of 375) and the same ones a video in the article body
   * gets. A width of 100% would have made it as wide as the whole column and
   * the margins would have pushed it off both edges of the screen.
   */
  aspect-ratio: 9/16;
  border-radius: 1px;
  overflow: hidden;
  cursor: pointer;
  background-color: #000;

  ${device.medium} {
    /**
     * With the gutters gone the block is narrower than the column, and Content
     * zeroes the auto margins that would have centred it - in the article body,
     * where the parent is a plain block and that rule does not reach, they
     * still do. Centring through the flex parent is not affected by it.
     */
    width: 100%;
    align-self: center;
    margin-bottom: 40px;
  }
`

export const Poster = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

export const Shade = styled.div`
  position: absolute;
  inset: 0;
  /* same gradient the vertical player already uses for its overlay */
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 59.99%, #000 103.03%);
  pointer-events: none;
`

export const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  filter: drop-shadow(0 9px 4.5px rgba(0, 0, 0, 0.4));
  pointer-events: none;

  svg {
    width: 100%;
    height: 100%;
  }

  ${device.medium} {
    width: 60px;
    height: 60px;
  }
`

export const Duration = styled.div`
  position: absolute;
  left: 6.44px;
  bottom: 7.73px;
  display: flex;
  align-items: center;
  gap: 2.577px;
  /* the page is RTL, which would flip the row and put the time before the
       glyph - a play glyph and a timecode are not language, so keep them LTR */
  direction: ltr;

  p {
    margin-bottom: 0 !important;
    color: #fff;
    font-family: ${fonts.narkis};
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
  }

  ${device.medium} {
    left: 9.62px;
    bottom: 11.54px;
    gap: 3.846px;

    p {
      font-size: 20px;
      margin-bottom: 0;
    }
  }
`

/**
 * Figma draws the play glyph inside a larger transparent box (20.615px on
 * mobile, 30.769px on desktop) - the box is what aligns with the time, the
 * glyph inside it is smaller.
 */
export const DurationIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20.615px;
  height: 20.615px;

  svg {
    width: 16px;
    height: 16px;
  }

  ${device.medium} {
    width: 30.769px;
    height: 30.769px;

    svg {
      width: 23.9px;
      height: 23.9px;
    }
  }
`
